import { type SwanStyleProps, Typography } from '@vp/swan'
import { useLocalizations } from '@vp/ubik-localizations-provider'

import type { ColorOptionProduct } from '../../../types/ColorOptionProduct'
import { useProject } from '../../root/contexts/ProjectContext'
import { getColorKey } from './colorOptionHelpers'
import useAvailableColorOptions from '../../../hooks/queries/useAvailableColorOptions'

interface ColorNameProps {
  colorOptionProduct?: ColorOptionProduct
  className?: string
}

export const ColorName: React.FC<SwanStyleProps & ColorNameProps> = ({ colorOptionProduct, className, ...props }) => {
  const { t } = useLocalizations()
  const { lowestPriceAttributes, work } = useProject()
  const { data: availableColorOptions } = useAvailableColorOptions()

  const selectedColor =
    colorOptionProduct ??
    availableColorOptions?.find((option) => option.hexColorValue === work.merchandising.merchandisingSelections[getColorKey(lowestPriceAttributes)])

  return (
    <Typography {...props} className={className}>
      {`${t('color-options.color')}: ${
        selectedColor?.colorName || selectedColor?.hexColorValue || work.merchandising.merchandisingSelections[getColorKey(lowestPriceAttributes)]
      }`}
    </Typography>
  )
}
